module.exports = function() {
	return new Worker(__webpack_public_path__ + "worker-slave.parallel-es6.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader?name=worker-slave!./src/browser/worker-slave/index.ts
// module id = 34
// module chunks = 0